/* @flow */
import * as React from 'react';
import { css, names } from 'linaria';

function AspectRatio({
  children,
  maxHeight = 560,
  minHeight,
  className,
  style,
  contentClassName,
}: {
  children?: any,
  maxHeight?: number,
  minHeight?: number,
  className?: string,
  contentClassName?: string,
  style?: {},
}) {
  return (
    <div className={className} style={style}>
      <div className={Styles.Aspect} style={{ minHeight, maxHeight }}>
        <div className={names(Styles.Content, contentClassName)}>{children}</div>
      </div>
    </div>
  );
}

const Styles = {
  Content: css`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  `,
  Aspect: css`
    display: block;
    overflow: hidden;
    position: relative;
    &:before {
      content: ' ';
      display: block;
      padding-bottom: 56.25%;
    }
  `,
};

export default AspectRatio;



// WEBPACK FOOTER //
// ./src/ui/components/AspectRatio.js